module.exports = require '../../lib/current_user.coffee'
